import React from 'react';
import { Card, Typography, Button } from 'antd';

const { Title, Text } = Typography;

export const ErrorState = ({ error, onRetry }) => {
  return (
    <div className="layout-content">
      <Card bordered={false}>
        <div style={{ textAlign: 'center', padding: '50px' }}>
          <Title level={4}>Error loading dashboard data</Title>
          <Text type="danger">{error}</Text>
          <br />
          <Button type="primary" onClick={onRetry} style={{ marginTop: '20px' }}>
            Retry
          </Button>
        </div>
      </Card>
    </div>
  );
};  